// @ts-nocheck
class SiteHeader extends HTMLElement {
  constructor() {
    super();
    this.config = {
      duration: 500,
      accordionSpeed: 300,
      classes: {
        scrolled: 'scrolled',
        open: 'nav__burger--open',
        visible: 'visible',
        hidden: 'hidden',
      },
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.calculateThreshold = this.calculateThreshold.bind(this);
    this.headerGroup = null;
  }

  connectedCallback() {
    this.initSticky();
    this.initMobileMenu();
    this.initLazySwipers();
    this.initDesktopInteractions();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.calculateThreshold);
    if (this.desktopDocumentClickHandler) {
      document.removeEventListener('click', this.desktopDocumentClickHandler);
    }
    if (this.desktopKeydownHandler) {
      document.removeEventListener('keydown', this.desktopKeydownHandler);
    }
  }

  // STICKY HEADER
  initSticky() {
    this.headerGroup = document.querySelector('.shopify-section-group-header-group.nav');
    this.announcementBar = document.querySelector('.announcement-bar');

    if (!this.headerGroup) {
      this.headerGroup = this;
    }

    this.threshold = 0;
    this.isScrolled = false;
    this.ticking = false;

    this.calculateThreshold();

    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.calculateThreshold, { passive: true });

    if (this.announcementBar) {
      new ResizeObserver(this.calculateThreshold).observe(this.announcementBar);
    }
    this.vipBar = document.querySelector('.vipBanner');
    if (this.vipBar) {
      new ResizeObserver(this.calculateThreshold).observe(this.vipBar);
    }
  }

  calculateThreshold() {
    const announcementHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
    const headerHeight = this.headerGroup.offsetHeight;
    this.threshold = announcementHeight + headerHeight;
    this.syncBarHeightVars();
    this.handleScroll();
  }

  syncBarHeightVars() {
    const annBar = document.querySelector('.shopify-section.announcement-bar');
    const vipBar = document.querySelector('.vipBanner');
    const annHeight = annBar ? annBar.offsetHeight : 0;
    const vipHeight = vipBar ? vipBar.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-bar-height', `${annHeight}px`);
    document.documentElement.style.setProperty('--vip-banner-height', `${vipHeight}px`);
  }

  handleScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        const currentScroll = window.scrollY;
        const shouldBeScrolled = currentScroll > this.threshold;

        if (shouldBeScrolled !== this.isScrolled) {
          this.headerGroup.classList.toggle(this.config.classes.scrolled, shouldBeScrolled);
          this.isScrolled = shouldBeScrolled;
        }
        this.ticking = false;
      });
      this.ticking = true;
    }
  }
  // MOBILE DRAWER MENU
  initMobileMenu() {
    const navBurgerBtn = this.querySelector('button.nav__burger');
    const navMain = this.querySelector('.nav__main');

    if (!navBurgerBtn || !navMain) return;

    const body = document.body;
    const navMask = navMain.querySelector('.nav__mask');
    const navHolder = navMain.querySelector('.nav__holder');
    const drawerMenu = navMain.querySelector('.drawerMenu');
    const drawerMenuList = drawerMenu ? drawerMenu.querySelector('.drawerMenu__list') : null;
    const drawerMenuItems = drawerMenuList ? drawerMenuList.querySelectorAll(':scope > .drawerMenu__item') : [];
    const scrollContainer = navMain.querySelector('.drawerMenu__holder[drawer-menu-holder]');
    const drawerFooterList = navMain.querySelector('[drawer-menu-footer-list]');

    const populateDrawerFooter = () => {
      if (!drawerFooterList || drawerFooterList.children.length) return;
      const links = document.querySelectorAll('.announcementBar__list .announcementBar__link');
      if (!links.length) return;
      drawerFooterList.innerHTML = '';
      links.forEach((link) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = link.href;
        a.textContent = link.textContent.trim();
        li.appendChild(a);
        drawerFooterList.appendChild(li);
      });
    };
    populateDrawerFooter();
    const setInitialStyles = () => {
      if (navMask)
        navMask.style.transition = `opacity ${this.config.duration}ms ease, visibility ${this.config.duration}ms ease`;
      if (navHolder) navHolder.style.transition = `transform ${this.config.duration}ms ease`;
      if (drawerMenuList) drawerMenuList.style.transition = 'transform 300ms ease';

      drawerMenuItems.forEach((item) => {
        item.style.transition = `opacity ${this.config.duration}ms ease, transform ${this.config.duration}ms ease`;
        item.style.opacity = '0';
        item.style.transform = 'translateX(-60px)';
      });
    };
    setInitialStyles();

    const resetScroll = () => {
      if (scrollContainer) scrollContainer.scrollTop = 0;
    };

    const resetMenuInternalState = () => {
      if (drawerMenuList) drawerMenuList.style.transform = 'translateX(0%)';
      resetScroll();
      this.classList.remove('mobile-menu-open');
      this.classList.remove('mobile-submenu-open');

      // Close Sub-menus (Level 1)
      const openSubs = drawerMenu.querySelectorAll('.drawerMenu__list--sub.visible');
      openSubs.forEach((sub) => {
        sub.classList.remove(this.config.classes.visible);
        sub.setAttribute('aria-hidden', 'true');
      });

      // Close Accordions (Level 2)
      const openAccordions = drawerMenu.querySelectorAll('.drawerMenu__list--accordion[aria-hidden="false"]');
      openAccordions.forEach((acc) => {
        acc.style.maxHeight = '0px';
        acc.setAttribute('aria-hidden', 'true');
      });

      // Reset aria-expanded
      const expandedBtns = drawerMenu.querySelectorAll('[aria-expanded="true"]');
      expandedBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
    };

    const closeSiblings = (currentSubList, parentList) => {
      if (!parentList) return;
      const openSiblings = parentList.querySelectorAll('ul.drawerMenu__list--accordion[aria-hidden="false"]');
      openSiblings.forEach((openSub) => {
        if (openSub !== currentSubList) {
          openSub.style.maxHeight = '0px';
          openSub.setAttribute('aria-hidden', 'true');
          const wrapper = openSub.closest('li');
          const sibBtn = wrapper ? wrapper.querySelector('.drawerMenu__link--accordion') : null;
          if (sibBtn) sibBtn.setAttribute('aria-expanded', 'false');
        }
      });
    };

    const goBackOneLevel = () => {
      if (!drawerMenuList || !drawerMenu) return;
      const activeSub = drawerMenu.querySelector('.drawerMenu__list--sub.visible');
      if (!activeSub) return;
      drawerMenuList.style.transform = 'translateX(0%)';
      this.classList.remove('mobile-submenu-open');
      const parentSubContainer = activeSub.parentElement;
      const prevBtn = parentSubContainer ? parentSubContainer.querySelector('.drawerMenu__link') : null;
      if (prevBtn) prevBtn.setAttribute('aria-expanded', 'false');
      activeSub.classList.remove(this.config.classes.visible);
      activeSub.setAttribute('aria-hidden', 'true');
      resetScroll();
    };

    // --- Burger Click Event ---
    navBurgerBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();

      if (this.classList.contains('mobile-submenu-open') && navBurgerBtn.classList.contains(this.config.classes.open)) {
        goBackOneLevel();
        return;
      }

      const isOpen = navBurgerBtn.classList.toggle(this.config.classes.open);
      this.classList.toggle('mobile-menu-open', isOpen);
      navBurgerBtn.setAttribute('aria-expanded', isOpen);
      navBurgerBtn.setAttribute('aria-label', isOpen ? 'Close main menu' : 'Open main menu');
      if (drawerMenu) drawerMenu.setAttribute('aria-hidden', !isOpen);

      if (isOpen) {
        this.classList.remove('mobile-submenu-open');
        body.style.overflow = 'hidden';
        navMain.style.display = 'block';
        navMain.style.pointerEvents = 'all';
        resetScroll();

        // Animation Frame for smoother transition
        requestAnimationFrame(() => {
          if (navMask) {
            navMask.style.pointerEvents = 'all';
            navMask.style.visibility = 'inherit';
            navMask.style.opacity = '1';
          }
          if (navHolder) navHolder.style.transform = 'translate(0px, 0px)';

          drawerMenuItems.forEach((item, index) => {
            item.style.transitionDelay = `${this.config.duration / 4 + index * 50}ms`;
            item.style.opacity = '1';
            item.style.visibility = 'inherit';
            item.style.transform = '';
          });
        });
      } else {
        this.classList.remove('mobile-submenu-open');
        body.style.overflow = 'auto';
        if (navMask) {
          navMask.style.pointerEvents = 'none';
          navMask.style.opacity = '0';
          navMask.style.visibility = 'hidden';
        }
        if (navHolder) navHolder.style.transform = 'translate(-100%, 0px)';

        drawerMenuItems.forEach((item) => {
          item.style.transitionDelay = '0s';
          item.style.opacity = '0';
          item.style.transform = 'translateX(-60px)';
        });

        setTimeout(() => {
          if (!navBurgerBtn.classList.contains(this.config.classes.open)) {
            navMain.style.display = 'none';
            navMain.style.pointerEvents = 'none';
            resetMenuInternalState();
          }
        }, this.config.duration);
      }
    });

    // --- Menu Items Interactions ---
    if (drawerMenu) {
      drawerMenu.addEventListener('click', (e) => {
        const target = e.target;

        // Logic A: Accordion Toggle
        const accBtn = target.closest('.drawerMenu__link--accordion');
        if (accBtn) {
          e.preventDefault();
          e.stopPropagation();

          const parentItem = accBtn.closest('.drawerMenu__item');
          const subList = parentItem.querySelector('ul.drawerMenu__list--accordion');
          if (!subList) return;

          // Original: closeSiblings(subList, parentItem.closest('ul'));
          closeSiblings(subList, parentItem.closest('ul'));

          const isHidden = subList.getAttribute('aria-hidden') === 'true';
          if (isHidden) {
            accBtn.setAttribute('aria-expanded', 'true');
            subList.setAttribute('aria-hidden', 'false');
            subList.style.maxHeight = subList.scrollHeight + 'px';
            subList.style.transition = `max-height ${this.config.accordionSpeed}ms ease`;
          } else {
            accBtn.setAttribute('aria-expanded', 'false');
            subList.setAttribute('aria-hidden', 'true');
            subList.style.maxHeight = '0px';
          }
          return;
        }

        // Logic B: Slide Forward
        const slideBtn = target.closest('.drawerMenu__link');
        if (slideBtn) {
          const parentItem = slideBtn.closest('.drawerMenu__item');
          const subList = parentItem ? parentItem.querySelector('.drawerMenu__list--sub') : null;
          if (subList && !subList.classList.contains('drawerMenu__list--accordion')) {
            e.preventDefault();
            resetScroll();

            drawerMenuList.style.transform = 'translateX(-100%)';
            this.classList.add('mobile-submenu-open');
            slideBtn.setAttribute('aria-expanded', 'true');
            subList.setAttribute('aria-hidden', 'false');
            subList.classList.add(this.config.classes.visible);
            return;
          }
        }

        // Logic C: Back Button
        const backItem = target.closest('li.drawerMenu__item');
        if (backItem) {
          const parentSubList = backItem.closest('.drawerMenu__list--sub');
          // Check if the clicked item is strictly the first item (Back button)
          if (parentSubList && parentSubList.querySelector('li.drawerMenu__item') === backItem) {
            e.preventDefault();
            e.stopPropagation();

            drawerMenuList.style.transform = 'translateX(0%)';
            this.classList.remove('mobile-submenu-open');
            // Find parent trigger to remove focus/active state if needed
            // (Simulating original logic logic)
            const parentSubContainer = parentSubList.parentElement;
            const prevBtn = parentSubContainer ? parentSubContainer.querySelector('.drawerMenu__link') : null;

            if (prevBtn) prevBtn.setAttribute('aria-expanded', 'false');
            parentSubList.classList.remove(this.config.classes.visible);
          }
        }
      });
    }
  }

  // SWIPERS
  initLazySwipers() {
    const carousels = this.querySelectorAll('li.drawerMenu__carousel.swiper');
    if (carousels.length === 0) return;

    const swiperDefaults = {
      slidesPerView: 'auto',
      spaceBetween: 10,
      slidesOffsetBefore: 20,
      observer: true,
      observeParents: true,
    };

    const swiperObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target;
            if (el.classList.contains('swiper-initialized')) {
              observer.unobserve(el);
              return;
            }
            const optionsAttr = el.getAttribute('carousel-options');
            let customOptions = {};
            try {
              if (optionsAttr) customOptions = JSON.parse(optionsAttr);
            } catch (e) {
              console.warn('Invalid JSON in carousel-options');
            }
            if (el.querySelector('.swiper-wrapper')) {
              const initSwiper = () => new Swiper(el, { ...swiperDefaults, ...customOptions });
              if (typeof window.whenSwiperReady === 'function') {
                window.whenSwiperReady(initSwiper);
              } else if (typeof Swiper !== 'undefined') {
                initSwiper();
              }
            }

            observer.unobserve(el);
          }
        });
      },
      { rootMargin: '0px', threshold: 0.1 }
    );

    carousels.forEach((el) => swiperObserver.observe(el));
  }

  initDesktopInteractions() {
    const desktopMq = window.matchMedia('(min-width: 1025px)');
    const searchWrap = this.querySelector('[desktop-search]');
    const searchToggle = this.querySelector('[desktop-search-toggle]');
    const searchInput = this.querySelector('.nav__buttons .customSearch__input');
    const drawerToggle = this.querySelector('[desktop-drawer-toggle]');

    if (!searchWrap || !searchToggle || !drawerToggle) return;

    const closeSearch = () => {
      this.classList.remove('desktop-search-open');
      searchToggle.setAttribute('aria-expanded', 'false');
    };
    const openSearch = () => {
      this.classList.add('desktop-search-open');
      searchToggle.setAttribute('aria-expanded', 'true');
      if (searchInput) searchInput.focus();
    };

    searchToggle.addEventListener('click', (event) => {
      event.preventDefault();
      if (!desktopMq.matches) return;
      const willOpen = !this.classList.contains('desktop-search-open');
      if (willOpen) {
        this.closeMegaMenu();
        openSearch();
      } else {
        closeSearch();
      }
    });

    drawerToggle.addEventListener('click', (event) => {
      event.preventDefault();
      if (!desktopMq.matches) return;
      const megaMenu = this.querySelector('[desktop-mega-menu]');
      if (!megaMenu) return;
      const willOpen = megaMenu.getAttribute('aria-hidden') !== 'false';
      if (willOpen) {
        closeSearch();
        this.openMegaMenu(megaMenu);
      } else {
        this.closeMegaMenu();
      }
    });

    this.desktopDocumentClickHandler = (event) => {
      if (!desktopMq.matches) return;
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const clickedInsideSearch =
        !!target.closest('[desktop-search]') ||
        !!target.closest('[desktop-search-toggle]') ||
        !!target.closest('custom-predictive-search.customSearch') ||
        !!target.closest('.customSearch__wrapper') ||
        !!target.closest('.customSearch__content');

      // Temporarily disabled per request — keep search open when clicking outside.
      // if (!clickedInsideSearch) { closeSearch(); }
    };
    document.addEventListener('click', this.desktopDocumentClickHandler);

    this.desktopKeydownHandler = (event) => {
      if (!desktopMq.matches || event.key !== 'Escape') return;
      closeSearch();
      this.closeMegaMenu();
    };
    document.addEventListener('keydown', this.desktopKeydownHandler);

    // Wire up the mega menu interactions
    this.initDesktopMegaMenu();
  }

  initDesktopMegaMenu() {
    const megaMenu = this.querySelector('[desktop-mega-menu]');
    if (!megaMenu) return;

    // Close buttons & backdrop
    megaMenu.querySelectorAll('[desktop-mega-close]').forEach((el) => {
      el.addEventListener('click', () => this.closeMegaMenu());
    });

    megaMenu.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const toggleBtn = target.closest('.megaMenu__submenuToggle');
      if (!toggleBtn) return;
      event.preventDefault();
      const willOpen = toggleBtn.getAttribute('aria-expanded') !== 'true';
      this.toggleDesktopAccordion(toggleBtn, willOpen);
    });

    // Hover / click on left nav items → update middle panel
    megaMenu.querySelectorAll('.megaMenu__navItem').forEach((item) => {
      item.addEventListener('mouseenter', () => this.activateMegaMenuItem(megaMenu, item));
      item.addEventListener('click', (e) => {
        // On desktop allow link to follow; on mobile prevent and expand
        if (window.innerWidth < 1025) {
          e.preventDefault();
          this.activateMegaMenuItem(megaMenu, item);
        }
      });
    });
  }

  openMegaMenu(megaMenu) {
    if (!megaMenu) megaMenu = this.querySelector('[desktop-mega-menu]');
    if (!megaMenu) return;
    megaMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    // Activate the first item ("New In") by default
    const firstItem = megaMenu.querySelector('.megaMenu__navItem');
    if (firstItem) this.activateMegaMenuItem(megaMenu, firstItem);
    // Populate footer from announcementBar
    this.populateMegaMenuFooter(megaMenu);
  }

  closeMegaMenu() {
    const megaMenu = this.querySelector('[desktop-mega-menu]');
    if (!megaMenu) return;
    megaMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  activateMegaMenuItem(megaMenu, item) {
    megaMenu.querySelectorAll('.megaMenu__navItem').forEach((i) => i.classList.remove('is-active'));
    megaMenu.querySelectorAll('.megaMenu__submenu').forEach((s) => s.classList.remove('is-active'));
    megaMenu.querySelectorAll('.megaMenu__promo').forEach((p) => p.classList.remove('is-active'));
    item.classList.add('is-active');
    const key = item.dataset.menuKey;
    if (key) {
      const submenu = megaMenu.querySelector(`.megaMenu__submenu[data-submenu="${key}"]`);
      if (submenu) submenu.classList.add('is-active');
      const promo = megaMenu.querySelector(`.megaMenu__promo[data-promo="${key}"]`);
      if (promo) promo.classList.add('is-active');
      if (submenu) {
        requestAnimationFrame(() => {
          this.resetDesktopAccordions(submenu);
          this.openFirstDesktopAccordion(submenu);
        });
      }
    }
  }

  resetDesktopAccordions(scope) {
    if (!scope) return;
    scope.querySelectorAll('.megaMenu__submenuToggle[aria-expanded="true"]').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
    scope.querySelectorAll('.megaMenu__submenuNested[aria-hidden="false"]').forEach((list) => {
      list.setAttribute('aria-hidden', 'true');
      list.style.maxHeight = '0px';
    });
  }

  toggleDesktopAccordion(button, willOpen) {
    if (!button) return;
    const parentItem = button.closest('.megaMenu__submenuItem');
    const currentList = parentItem ? parentItem.querySelector('.megaMenu__submenuNested') : null;
    const submenuContainer = button.closest('.megaMenu__submenu');
    if (!currentList || !submenuContainer) return;

    submenuContainer.querySelectorAll('.megaMenu__submenuToggle').forEach((btn) => {
      const btnItem = btn.closest('.megaMenu__submenuItem');
      const btnList = btnItem ? btnItem.querySelector('.megaMenu__submenuNested') : null;
      if (btn !== button && btnList) {
        btn.setAttribute('aria-expanded', 'false');
        btnList.setAttribute('aria-hidden', 'true');
        btnList.style.maxHeight = '0px';
      }
    });

    button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    currentList.setAttribute('aria-hidden', willOpen ? 'false' : 'true');
    currentList.style.maxHeight = willOpen ? `${currentList.scrollHeight}px` : '0px';
  }

  openFirstDesktopAccordion(scope) {
    if (!scope) return;
    const firstToggle = scope.querySelector('.megaMenu__submenuToggle');
    if (!firstToggle) return;
    this.toggleDesktopAccordion(firstToggle, true);
  }

  populateMegaMenuFooter(megaMenu) {
    const footerList = megaMenu.querySelector('.megaMenu__footerList');
    if (!footerList) return;
    // Only populate once
    if (footerList.children.length) return;
    const barLinks = document.querySelectorAll('.announcementBar__list .announcementBar__link');
    if (!barLinks.length) return;
    barLinks.forEach((link) => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.textContent.trim();
      li.appendChild(a);
      footerList.appendChild(li);
    });
  }
}

customElements.define('site-header', SiteHeader);